import TextFade from "../../components/CustomTexts/TextFade";
// import CallToActionSection from "../../components/Others/CallToActionSection";
import heroImage from "../../assets/Shabu-Training-2021/ok.jpg";
import sandDredgingImage from "../../assets/Shabu-Training-2021/training.jpg";
import missionImage from "../../assets/Iwomen.png";
import TextEffect from "../../components/CustomTexts/TextEffect";
import bgIMG from "../../assets/tan2.jpg";
import sti4Img from "../../assets/STI/LEADER.jpg";
import trainingImg from "../../assets/Shabu-Training-2021/big.jpg";
import naqImg from "../../assets/naq6.jpeg";
import sahelImg from "../../assets/sahel-2023-changemakers/sahel3.jpg";
import sahel10Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/4.jpg";
 import farmImg from "../../assets/KEDA/keda1.jpg";
import calabarImg from "../../assets/calabar/cal1.jpg";
import minnaImg from "../../assets/minna/OFSP_Bread_8.jpg";
import holycrossImg from "../../assets/holycross/holy2.jpg";
import naq2Img from "../../assets/naq2.jpeg";
import women1Img from "../../assets/2022/WHATSA~4.jpg";
import holycross1Img from "../../assets/holycross/holy1.jpg";
import calabar2Img from "../../assets/calabar/cal2.jpg";
import calabar3Img from "../../assets/calabar/cal3.jpg";
import calabar4Img from "../../assets/calabar/cal4.jpg";
import calabar5Img from "../../assets/calabar/cal5.jpg";
import calabar6Img from "../../assets/calabar/cal6.jpg";
import calabar7Img from "../../assets/calabar/cal7.jpg";
import calabar8Img from "../../assets/calabar/cal8.jpg";
import naq3Img from "../../assets/naq3.jpeg";
import naq4Img from "../../assets/naq4.jpeg";
import wactcsrImg from "../../assets/wact.jpg";
import mofiImg from "../../assets/new1.jpg";
import naq5Img from "../../assets/naq5.jpeg";
import naq6Img from "../../assets/naq1.jpeg";
import minna2Img from "../../assets/minna/OFSPBread2.jpg";
import minna3Img from "../../assets/minna/minna3.jpeg";
import minna5Img from "../../assets/minna/minna.jpeg";
import minna7Img from "../../assets/minna/minna3.jpeg";
import { Link, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { useState } from "react";
import visaIcon from "../../assets/294654_visa_icon.svg";
import mastercardIcon from "../../assets/card.png";

const ImageModal = ({ image, caption, onClose }: { image: string, caption: string, onClose: () => void }) => (
  <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-lg shadow-lg max-w-3xl w-full overflow-hidden relative">
      <img src={image} alt={caption} className="w-full max-h-[80vh] object-contain" />
      <p className="text-center text-lg font-semibold text-dark py-4">{caption}</p>
      <button
        onClick={onClose}
        className="absolute top-2 right-2 text-white bg-black rounded-full p-2 hover:bg-gray-700"
      >
        ✕
      </button>
    </div>
  </div>
);

const QuarryPage = () => {
  const [modal, setModal] = useState<{ img: string; caption: string } | null>(null);
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    card: "",
    expiry: "",
    cvv: ""
  });
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [processing, setProcessing] = useState(false);

  const trainingGallery = [
  { img: holycrossImg, caption: "Hands-On Workshop" },
  { img: naq3Img, caption: "Collaborative Learning" },
  { img: calabar4Img, caption: "Skill Development" },
  { img: minna2Img, caption: "Bread Production Techniques" },
  { img: naq6Img, caption: "Real-World Impact" },
  { img: calabar2Img, caption: "Practical Training" },
  { img: holycross1Img, caption: "Interactive Learning" },
  { img: minna5Img, caption: "Quality Ingredients" },
  { img: naq4Img, caption: "Knowledge Sharing" },
  { img: calabar6Img, caption: "Sustainable Practices" },
  { img: minna3Img, caption: "Hands-On Bread Making" },
  { img: calabar8Img, caption: "Hands-On Experience" },
  { img: naq2Img, caption: "Expert Guidance" },
  { img: calabar7Img, caption: "Empowering Farmers" },
  { img: trainingImg, caption: "Personalized Mentorship" },
  { img: minna7Img, caption: "Community Baking Sessions" },
  { img: naq5Img, caption: "Practical Applications" },
  { img: calabar3Img, caption: "Community Engagement" },
  { img: calabar5Img, caption: "Innovative Techniques" },
  { img: naq2Img, caption: "NAQS Training Session" },
  { img: wactcsrImg, caption: "WACT CSR Training" },
  { img: sahelImg, caption: "Sahel 2023 Conference" },
  { img: sahel10Img, caption: "Sahel 2024 Conference" },
  { img: women1Img, caption:  "2022 Rural"},
  { img: sti4Img, caption: "FMSTI 2024 Expo" },
  { img: mofiImg, caption: "MOFI Investment Forum" },
];


  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};
    if (!form.name || form.name.length > 50) newErrors.name = "Full name required (max 50 chars).";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) newErrors.email = "Invalid email.";
    if (!/^\d{10,15}$/.test(form.phone)) newErrors.phone = "Phone number must be 10-15 digits.";
    if (!/^\d{16}$/.test(form.card)) newErrors.card = "Card number must be 16 digits.";
    if (!/^(0[1-9]|1[0-2])\/\d{2}$/.test(form.expiry)) newErrors.expiry = "Invalid expiry format MM/YY.";
    if (!/^\d{3,4}$/.test(form.cvv)) newErrors.cvv = "CVV must be 3 or 4 digits.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e: { preventDefault: () => void; }) => {
    e.preventDefault();
    if (validateForm()) {
      setProcessing(true);
      setTimeout(() => {
        navigate("/confirmation");
      }, 3000);
    }
  };

  return (
    <div className="about-container">
      <div className="relative h-[60vh] flex items-center justify-center text-white bg-cover bg-center z-0" style={{ backgroundImage: `url(${heroImage})` }}>
        <div className="absolute inset-0 bg-black opacity-50 z-0"></div>
        <div className="z-10">
          <TextEffect text="Training & Mentorship" className="hero-title" />
        </div>
      </div>

      {/* Payment Form */}
      <div className="px-4 sm:px-[5%] mt-20 mb-10">
        <div className="bg-white shadow-md rounded-lg p-6 md:p-10 max-w-4xl mx-auto">
          <h2 className="text-[22px] md:text-[32px] font-bold text-center text-dark mb-10">
            <TextEffect part3="Register For Upcoming Training" />
          </h2>
          <form className="space-y-4" onSubmit={handleSubmit}>
            <input name="name" type="text" placeholder="Full Name" value={form.name} onChange={handleChange} className="w-full p-3 rounded-md border border-gray-300" />
            {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
            <input name="email" type="email" placeholder="Email Address" value={form.email} onChange={handleChange} className="w-full p-3 rounded-md border border-gray-300" />
            {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
            <input name="phone" type="tel" placeholder="Phone Number" value={form.phone} onChange={handleChange} className="w-full p-3 rounded-md border border-gray-300" />
            {errors.phone && <p className="text-red-500 text-sm">{errors.phone}</p>}
            <div className="relative">
              <input name="card" type="text" placeholder="Card Number" value={form.card} onChange={handleChange} className="w-full p-3 rounded-md border border-gray-300" />
              <div className="absolute top-2 right-4 flex items-center gap-2">
                <img src={visaIcon} alt="Visa" className="h-6" />
                <img src={mastercardIcon} alt="MasterCard" className="h-6" />
              </div>
            </div>
            {errors.card && <p className="text-red-500 text-sm">{errors.card}</p>}
            <div className="flex gap-4">
              <input name="expiry" type="text" placeholder="MM/YY" value={form.expiry} onChange={handleChange} className="w-1/2 p-3 rounded-md border border-gray-300" />
              <input name="cvv" type="text" placeholder="CVV" value={form.cvv} onChange={handleChange} className="w-1/2 p-3 rounded-md border border-gray-300" />
            </div>
            {errors.expiry && <p className="text-red-500 text-sm">{errors.expiry}</p>}
            {errors.cvv && <p className="text-red-500 text-sm">{errors.cvv}</p>}
            <button type="submit" className="w-full bg-secondary text-white py-3 rounded-md hover:shadow-lg transition-all">
              {processing ? 'Processing Payment...' : 'Proceed to Pay'}
            </button>
          </form>
        </div>
      </div>

      {/* Confirmation Redirect Placeholder */}
      {processing && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded shadow-md text-center">
            <p className="text-lg font-semibold">Processing your payment...</p>
          </div>
        </div>
      )}

      {/* What We Offer */}
      <div className="relative w-full px-8 sm:px-[7%] py-20 overflow-hidden">
        <div className="absolute inset-0 w-full h-full bg-cover bg-center z-0" style={{ backgroundImage: `url(${sandDredgingImage})` }} />
        <div className="absolute inset-0 bg-white opacity-70 z-0" />
        <div className="relative z-10 flex md:flex-row flex-col-reverse justify-between items-center md:gap-20 gap-10">
          <div className="md:w-[55%] w-full text-right-[-10px]">
            <TextFade animation="fade-down">
              <h1 className="md:text-[60px] text-[28px] font-bold text-dark mb-6">
                <TextEffect part3="What We Offer" />
              </h1>
            </TextFade>
            <p className="text-dark md:text-[20px] text-[15px] leading-relaxed">
              Facilitating business connections within the agricultural value chain, ensuring market access for farmers and processed products.
            </p>
            <p className="text-dark md:text-[20px] text-[15px] mt-4 leading-relaxed">
              Beyond products, we provide training, farm establishment, vine supply, and consultancy services to support the full agricultural value chain.
            </p>
          </div>
        </div>
      </div>

    
    {/* Training Programs */}
<div className="px-4 sm:px-[5%] mt-10">
  <h2 className="text-[22px] md:text-[32px] font-bold text-center text-dark mb-10">
    <TextEffect part3="Our Training & Exhibitions" />
  </h2>

  <div className="grid md:grid-cols-3 gap-10">
    {[
      {
        title: "Shabu Training, Abuja",
        dateRange: "June 24th – 26th, 2021",
        subtext:
          "Empowering rural farmers with practical skills of orange sweet fleshed potatoes",
        image: trainingImg,
        status: "View Details",
        completed: true,
        link: "/services/training/shabu",
      },
      {
        title: "KEDA Training, Kogi",
        dateRange: "September 7th - 8th, 2021",
        subtext:
          "KEDA - Kogi Enterprise Development Agency Training on Orange Sweet Fleshed Potatoes",
        image: farmImg,
        status: "View Details",
        completed: true,
        link: "/services/training/keda",
      },
      {
        title: "Ainu Oju Training, Benue",
        dateRange: "July 1st - 3rd, 2021 ",
        subtext: "Training at Ainu, Oju Local Government Areas of Benue State powered by NAQS 2021",
        image: naqImg,
        status: "View Details",
        completed: true,
        link: "/services/training/naqs", 
      },
       {
        title: "Calabar Training, Cross River",
        dateRange: "September 2020",
        subtext:
          "Cross River 2 day empowerment training on value chain development of orange sweet fleshed potatoes",
        image: calabarImg,
        status: "View Details",
        completed: true,
        link: "/services/training/calabar",
      },
       {
        title: "Minna Bread Training",
        dateRange: "November 2024",
        subtext:
          "Minna Bread Training on Orange Sweet Fleshed Potatoes Bread Production",
        image: minnaImg,
        status: "View Details",
        completed: true,
        link: "/services/training/minna",
      },
       {
        title: "Holy Cross, Wuye - Abuja",
        dateRange: "May 9th, 2025",
        subtext:
          "Diocese of Abuja (Anglican Communion) Training, Church of the Holy Cross, Wuye Abuja.",
        image: holycrossImg,
        status: "View Details",
        completed: true,
        link: "/services/training/holycross",
      },
      {
        title: "Sahel 2023 Food Changemakers Conference",
        dateRange: "2023",
        subtext:
          "Sahel 2023 Food Changemakers Conference, Simdozi was among the exhibitors at the event.",
        image: sahelImg,
        status: "View Details",
        completed: true,
        link: "/services/training/sahel23",
      },
      {
        title: "Sahel 2024 Food Changemakers Conference",
        dateRange: "2024",
        subtext:
          "In 2024, Sahel Food Changemakers Conference to showcase our work in the OFSP value chain development..",
        image: sahel10Img,
        status: "View Details",
        completed: true,
        link: "/services/training/sahel24",
      },
      {
        title: "2022 International Day for Rural Women Exhibition, Abuja",
        dateRange: "October 15th 2022",
        subtext:
          "International Day for Rural Women at Sheda Kwali + Hon Minister Women Affairs Dame Pauline Tallen inspecting our stand.",
        image: women1Img,
        status: "View Details",
        completed: true,
        link: "/services/training/ruralwomen",
      },
      {
        title: "FMSTI 2024 Expo at Eagle Square Abuja",
        dateRange: "March 11th - 15th, 2024",
        subtext:
          "FMSTI Expo at Eagle Square Abuja. Orange Fleshed Sweet Potato value chain development exhibition.",
        image: sti4Img,
        status: "View Details",
        completed: true,
        link: "/services/training/fmsti2024",
      },
      {
        title: "Integrainium Investment Forum of Ministry of Finance Incorporated (MOFI).",
        dateRange: "2025",
        subtext:
          "Integrainium Investment Forum of Ministry of Finance Incorporated (MOFI). Showcasing our work in agricultural value chain development.",
        image: mofiImg,
        status: "View Details",
        completed: true,
        link: "/services/training/mofi",
      },
       {
        title: "West Africa Container Terminal Empowerment training CSR Project, Onne, Rivers",
        dateRange: "October, 2024 - 2025",
        subtext:
          "The Project was first targeted at 500 beneficiaries in 2024 but later increased to 1000 in 2025.",
        image: wactcsrImg,
        status: "View Details",
        completed: true,
        link: "/services/training/wactcsr",
      },
    ].map((item, index) => (
      <div
        key={index}
        className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all overflow-hidden group"
      >
        <img
          src={item.image}
          alt={item.title}
          className="w-full h-[200px] object-cover group-hover:scale-105 transition-transform duration-300"
        />
        <div className="p-5 space-y-2">
          <h3 className="text-[18px] md:text-[22px] font-semibold text-dark">
            {item.title}
          </h3>
          <p className="text-sm text-gray-500">{item.dateRange}</p>
          <p className="text-sm text-dark">{item.subtext}</p>

          <div className="w-full bg-gray-200 rounded-full h-3">
            <div
              className={`h-3 rounded-full ${
                item.completed
                  ? "bg-green-600 w-full"
                  : "bg-yellow-400 w-1/2"
              }`}
            />
          </div>

          <p
            className={`text-sm ${
              item.completed ? "text-green-600" : "text-yellow-500"
            } font-medium mt-1`}
          >
            {item.completed ? "100% Completed" : "Preparation Underway"}
          </p>

          {item.completed ? (
            <Link
              to={item.link}
              className="inline-block mt-3 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-full text-sm transition"
            >
              {item.status}
            </Link>
          ) : (
            <button
              disabled
              className="inline-block mt-3 bg-gray-400 cursor-not-allowed text-white px-4 py-2 rounded-full text-sm"
            >
              {item.status}
            </button>
          )}
        </div>
      </div>
    ))}
  </div>
</div>


      {/* How We Train Section */}
      <div className="relative mt-20">
        <div className="relative bg-green-500 text-white px-4 sm:px-[5%] py-20 bg-cover bg-center z-0" style={{ backgroundImage: `url(${bgIMG})` }}>
          <div className="absolute inset-0 bg-green-650 opacity-80 z-0" />
          <div className="relative z-10 flex md:flex-row flex-col justify-between items-center gap-16">
            <div className="md:w-[40%] w-full flex justify-center">
              <img src={missionImage} alt="Empowering Farmers" className="w-[80%] sm:w-full max-w-[350px] md:max-w-[450px]" />
            </div>
            <div className="md:w-[100%] w-full">
              <TextFade animation="fade-down">
                <h1 className="text-[20px] sm:text-[30px] md:text-[40px] font-bold text-white mb-4 leading-tight">
                  <TextEffect text1="How We Train " />
                </h1>
              </TextFade>
              <p className="text-white text-[15px] sm:text-[17px] md:text-[20px] leading-relaxed">
                There’s no one-size-fits-all solution. First, our trainers listen to farmers, learning from their experiences and seeking to understand their specific challenges.
              </p>
              <br />
              <p className="text-white text-[15px] sm:text-[17px] md:text-[20px] leading-relaxed">
                A global team of regionally based and native-speaking trainers use their understanding of the culture, language and context. The result is adaptable and practical techniques that are helping families and communities feed themselves.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Previous Trainings Slider */}
      <div className="px-4 sm:px-[5%] mt-24 mb-20">
        <TextFade animation="fade-up">
          <h1 className="text-center text-[24px] md:text-[36px] font-bold text-dark mb-8">
            <TextEffect part3="Previous Trainings" />
          </h1>
        </TextFade>
        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 1.5 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 }
          }}
          navigation
          autoplay={{ delay: 3000 }}
          loop
          modules={[Navigation, Autoplay]}
        >
          {trainingGallery.map(({ img, caption }, index) => (
            <SwiperSlide key={index}>
              <div className="relative w-full h-[260px] sm:h-[300px] rounded-xl overflow-hidden group cursor-pointer" onClick={() => setModal({ img, caption })}>
                <img src={img} alt={`Training ${index + 1}`} className="w-full h-full object-cover group-hover:scale-105 transition-all duration-300" />
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center text-white text-lg font-semibold text-center p-4">
                  {caption}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Modal */}
      {modal && <ImageModal image={modal.img} caption={modal.caption} onClose={() => setModal(null)} />}
    </div>
  );
};

export default QuarryPage;